import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringEnterpriseEvolution() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="2508" id="bark-bath-mobile-grooming-experience" className="relative w-full overflow-hidden bg-background text-foreground bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600414/img/blue_bubbles_background_pattern.png)] bg-cover bg-center" ref={ref}>
      <div className="relative z-10 grid min-h-[800px] w-full grid-cols-1 lg:grid-cols-2">
        {}
        <div className="relative flex flex-col justify-center bg-white px-6 py-20 sm:px-12 lg:px-20 xl:px-32">
          <div className={`relative z-10 flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <h1 className="font-sans text-5xl font-bold tracking-tight text-foreground sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95]">
              Professional Grooming That Comes to{" "}
              <span className="text-[hsl(324,100%,60%)]">
                You
              </span>
            </h1>

            <p className="max-w-lg text-lg text-muted-foreground sm:text-xl leading-relaxed">Stress-free grooming, right at your door. We provide gentle, professional mobile dog grooming designed around your pup’s comfort, safety, and happiness. Proudly serving the greater South Jersey area.</p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button asChild size="lg" className="h-14 rounded-full px-10 text-lg font-semibold transition-transform hover:scale-105 bg-primary text-primary-foreground hover:bg-primary/90 border-none">
                <Link to="https://booking.moego.pet/ol/landing?name=BarkBathMobileGroomingLLC">
                  Book Now
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <Button asChild size="lg" className="h-14 rounded-full px-10 text-lg font-semibold transition-transform hover:scale-105 bg-[hsl(324,100%,60%)] text-primary-foreground hover:bg-[hsl(324,100%,60%)]/90 border-none">
                <Link to="tel:302-787-9274">
                  Call Now
                  <Phone className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="relative h-[500px] w-full lg:h-auto overflow-hidden bg-muted">
          <div className={`absolute inset-0 h-full w-full transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-105"}`} style={{
          clipPath: "polygon(0% 0, 100% 0, 100% 100%, 0% 100%)"
        }}>
            <img src="https://barkbathmobile.com/wp-content/uploads/2026/03/ChatGPT-Image-Mar-30-2026-06_51_17-AM.png" alt="A perfectly groomed Mini Goldendoodle" className="object-cover object-left w-full h-full" />
          </div>
        </div>
      </div>
    </section>;
}